import { cloneDeep, sortBy } from 'lodash';
import {
  RESET_APP_STATE,
  TOGGLE_MODAL,
  RESET_NOTES_TAB,
  RESET_EMAIL_TAB,
  RESET_HISTROY_TAB,
  GET_SCHEDULE_VISITS_CARD_FALIURE,
  GET_SCHEDULE_VISITS_CARD,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_FALIURE,
  GET_PATIENT_INFO_LOADING,
  GET_HEADER_INFO,
  GET_HEADER_INFO_FALIURE,
  GET_NOTES_FALIURE,
  GET_NOTES,
  RESET_PATIENT_INFO,
  GET_PRODUCT_INFO_FALIURE,
  GET_PRODUCT_INFO_LOADING,
  GET_PRODUCT_INFO,
  SET_PRODUCT_INFO,
  GET_PRODUCT_LIST_FALIURE,
  GET_PRODUCT_LIST,
  GET_QTY_BY_PRODUCT_ID_FALIURE,
  GET_QTY_BY_PRODUCT_ID,
  SAVE_PRODUCT_CHANGES_LOADING,
  SAVE_PRODUCT_CHANGES_FALIURE,
  SAVE_PRODUCT_CHANGES,
  TOGGLE_PRODUCT_CHANGE_MODAL,
  GET_CONSULT_QUESTION_FALIURE,
  GET_CONSULT_QUESTION,
  GET_CONSULT_QUESTION_LOADING,
  GET_PENDING_FILES_CARD_FALIURE,
  GET_PENDING_FILES_CARD,
  GET_ORDER_NOTES_FAILURE,
  GET_ORDER_NOTES,
  GET_PATIENT_NOTES,
  GET_SOAP_NOTE_INFO,
  GET_PATIENT_NOTES_FAILURE,
  GET_MEDICAL_ORDER_NOTES,
  GET_MEDICAL_ORDER_NOTES_FAILURE,
  GET_MEDICAL_PATIENT_NOTES,
  GET_MEDICAL_PATIENT_NOTES_FAILURE,
  SET_SELECTED_TAB,
  GET_EMAIL_FALIURE,
  GET_EMAIL,
  GET_HISTORY_FALIURE,
  GET_HISTORY,
  GET_EMAIL_TEMPLATE_FALIURE,
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATE_V2,
  GET_EMAIL_TEMPLATE_V2_LOADING,
  GET_EMAIL_TEMPLATE_V2_FAILURE,
  SET_DENIAL_AND_SEND_EMAIL,
  GET_DENIAL_REASON_FAILURE,
  GET_DENIAL_REASON,
  GET_SUB_AND_EMAIL_FALIURE,
  GET_SUB_AND_EMAIL,
  GET_SUB_AND_EMAIL_V2,
  RESET_SUB_AND_EMAIL_V2,
  DENIAL_AND_EMAIL,
  DENIAL_AND_EMAIL_FALIURE,
  RESET_EMAIL_AND_DENY_DATA,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO,

  GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE,
  GET_ORDER_AND_PRESCRIBER_FLAGS,
  GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING,
  RESET_ORDER_AND_PRESCRIBER_FLAGS,

  RESET_APPROVE_AND_MAIL_DATA,
  SET_APPROVE_AND_MAIL_DATA,
  SET_APPROVE_AND_MAIL_MAIN_DATA,
  HANDLE_GLOBAL_VALUE_CHANGE,
  VERIFY_PIN_FALIURE,
  VERIFY_PIN,
  TOGGLE_ERROR_MODAL,
  SET_MODAL_ALERT_OPEN,
  APPROVE_AND_MAIL_SUBMIT_FALIURE,
  APPROVE_AND_MAIL_SUBMIT,
  SET_START_VISIT,
  SET_START_VISIT_FALIURE,
  ADD_NOTE,
  ADD_SOAP_NOTE,
  ADD_NOTE_FAILURE,
  SET_ADD_NOTE,
  SET_ADD_SOAP_NOTE,
  RESET_ADD_NOTE_DATA,
  GET_REASONS_FALIURE,
  GET_REASONS,
  SEND_ORDER_TO_CS_FALIURE,
  SEND_ORDER_TO_CS,
  RESET_SEND_ORDER_TO_CS_DATA,
  SET_SEND_ORDER_TO_CS_DATA,
  GET_CALL_PATIENT_DETAILS,
  GET_CALL_PATIENT_DETAILS_FAILURE,
  RESET_CALL_PATIENT_DETAILS,
  SET_CALL_PATIENT_DETAILS,
  CALL_PATIENT_FAILURE,
  CALL_PATIENT,
  CALL_PATIENT_LOADING,
  SET_MODAL_TWILIO_ALERT_OPEN,
  RESET_EMAIL_PATIENT_DATA,
  EMAIL_PATIENT_DATA_FAILURE,
  EMAIL_PATIENT_DATA,
  EMAIL_PATIENT_DATA_LOADING,
  GET_TEXT_PATIENT_TEMPLATE_FALIURE,
  GET_TEXT_PATIENT_TEMPLATE,
  TEXT_PATIENT_FALIURE,
  TEXT_PATIENT,
  TEXT_PATIENT_LOADING,
  RESET_TEXT_PATIENT,
  POST_CALL_DETAILS_FALIURE,
  POST_CALL_DETAILS,
  CALL_END_FAILURE,
  GET_DOSESPOT_DATA_FALIURE,
  GET_DOSESPOT_DATA,
  RESET_DOSESPOT_DATA,
  LOG_ERROR_FALIURE,
  CHECK_DOSESPOT_FALIURE,
  CHECK_DOSESPOT,
  LOG_OFF_FALIURE,
  LOG_OFF,
  UPLOAD_DOC_PATIENT_FAILURE,
  UPLOAD_DOC_PATIENT,
  SET_UPLOAD_DOCS,
  PDF_DOC_FAILURE,
  PDF_DOC,
  SET_UPLOAD_PDFS,
  PDF_AV,
  PDF_AV_LOADING,
  PDF_NAV,
  SET_SEARCH_ERROR,
  SET_SEARCH_DATA_FAILURE,
  SET_SEARCH_DATA,
  CLEAR_SEARCH_DATA,
  CALL_SUMMARY_REASONS,
  SET_CALL_SUMMARY,
  SET_FILTER_BY,
  GET_SCHEDULE_VISITS_CARD_LOADING,
  GET_PENDING_FILES_CARD_LOADING,
  GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS,
  GET_PENDING_FILES_CARD_CLEAR_API_STATUS,
  SET_CMN_TEMPLATE_FORM_FIELD,
  SET_SOAP_NOTE_TEMPLATE,
  GET_SOAP_NOTE_TEMPLATES,
  GET_SOAP_NOTE_TEMPLATES_FAILURE,
  GET_SOAP_NOTE_TEMPLATES_LOADING,
  GET_PATIENT_UPLOADS,
  GET_PATIENT_UPLOADS_LOADING,
  GET_PATIENT_UPLOADS_FAILURE,
  GET_CHANGE_PRODUCT_LIST,
  GET_CHANGE_PRODUCT_LIST_LOADING,
  GET_CHANGE_PRODUCT_LIST_FAILURE,
  RESET_CHANGE_PRODUCT_LIST,
  GET_ALL_SUB_AND_EMAIL,
  GET_ALL_SUB_AND_EMAIL_LOADING,
  GET_ALL_SUB_AND_EMAIL_FAILURE,

  GET_PRODUCT_INFO_V3_LOADING,
  GET_PRODUCT_INFO_V3,
  GET_PRODUCT_INFO_V3_FAILURE,
  CLEAR_PRODUCT_INFO_V3,

  GET_EMAIL_REASONS_LOADING,
  GET_EMAIL_REASONS,
  GET_EMAIL_REASONS_FAILURE,

  GET_PRODUCT_COST_LOADING,
  GET_PRODUCT_COST,
  GET_PRODUCT_COST_FAILURE,
  RESET_PRODUCT_COST,

  ADD_PRODUCT_LOADING,
  ADD_PRODUCT,
  ADD_PRODUCT_FAILURE,

  GET_APPROVE_EMAIL_TEMPLATE_V2,
  GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING,
  GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE,

  GET_DENY_EMAIL_TEMPLATE_V2,
  GET_DENY_EMAIL_TEMPLATE_V2_LOADING,
  GET_DENY_EMAIL_TEMPLATE_V2_FAILURE,

  GET_SAVED_FLAGS,
  GET_SAVED_FLAGS_LOADING,
  GET_SAVED_FLAGS_FAILURE,
  RESET_SAVED_FLAGS,

  SAVE_FLAGS,
  SAVE_FLAGS_LOADING,
  SAVE_FLAGS_FAILURE,

  SAVE_EXTENDED_CONSULT,
  SAVE_EXTENDED_CONSULT_LOADING,
  SAVE_EXTENDED_CONSULT_FAILURE,
  GET_EMAIL_LOADING,
  GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING,
  GET_ORDER_NOTES_LOADING,
  GET_PATIENT_NOTES_LOADING,
  GET_MEDICAL_ORDER_NOTES_LOADING,
  GET_MEDICAL_PATIENT_NOTES_LOADING,
  REMOVE_ORDERS_FROM_LV,
  RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO,
  RESET_PRODUCT_INFO,
  GET_HISTORY_LOADING,

  SEND_PASSWORD_RECOVERY_OTP,

  VALIDATE_PASSWORD_RECOVERY_OTP,

  CLEAR_RECOVER_PASSWORD,
  RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP,
  SENT_PASSWORD_RECOVERY_OTP,
  FAILD_TO_SEND_PASSWORD_RECOVERY_OTP,
  VALIDATED_PASSWORD_RECOVERY_OTP,
  FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP,
  PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP,
  FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP,
  GET_QTY_BY_PRODUCT_ID_LOADING,
  SET_SEARCH_LOADING,
  GET_HEADER_INFO_LOADING,

  GET_TASKS_LOADING,
  GET_TASKS_FAILURE,
  GET_TASKS,
  GET_TASK_BY_ORDER_ID_LOADING,
  GET_TASK_BY_ORDER_ID,
  GET_TASK_BY_ORDER_ID_FAILURE,

  GET_ICD10CODES_BY_ORDER_ID_LOADING,
  GET_ICD10CODES_BY_PATIENT_ID_LOADING,
  GET_ICD10CODES_BY_ORDER_ID_FAILURE,
  GET_ICD10CODES_BY_ORDER_ID,
  GET_ICD10CODES_BY_PATIENT_ID_FAILURE,
  GET_ICD10CODES_BY_PATIENT_ID,
  GET_ICD10CODES_BY_TERMS_LOADING,
  GET_ICD10CODES_BY_TERMS,
  GET_ICD10CODES_BY_TERMS_FAILURE,
  REMOVE_ICD10CODE_FROM_COLLECTION,
  ADD_ICD10CODES_LOADING,
  ADD_ICD10CODES_FAILURE,
  ADD_ICD10CODES,
  REMOVE_ICD10CODES_LOADING,
  REMOVE_ICD10CODES_FAILURE,
  REMOVE_ICD10CODES,
  CLEAR_ICD10CODES_BY_TERMS,

  CHANGE_PASSWORD_IN_PROGRESS,
  PASSWORD_IS_CHANGED,
  FAILED_TO_CHANGE_PASSWORD,
} from "../reducerConstants";

import {
  ProvidersAndCreatePDF,
  PID_ProvidersAndCreatePDF,
  DEFAULT_FORMFIELD
} from '../../constants/cmnTemplateForEversense.constant';
// eslint-disable-next-line no-unused-vars
import { CONSULT_WITH_QUESTIONS, PRODUCT_INFORMATION, } from '../../constants/cmnTemplateForDexcom.constant';
import { APIData as apiData } from '../../constants/common.constant';
import {
  ProductInfo as productInfo,
  PatientInfo as patientInfo,
  EmailReason as emailReason,
  AddProductInfo as addProductInfo,
  ORDER_AND_PRESCRIBER_FLAGS,
  IEmailTemplate,
  IEmailTemplateWithProductId,
  SAVED_FLAGS,
  SAVED_FLAG,
  ORDERS,
  CRITICAL_FLAGS,
  DOCTOR_FLAGS,
  DefaultSFEmailTemplatesResponse,
  // eslint-disable-next-line no-unused-vars
  SF_EMAIL_TEMPLATES_RESPONSE,
} from '../../constants/visits.constant';
import { ALTERNATE_RX_PRODUCT_VALUE } from '../../constants/product.constant';
// eslint-disable-next-line no-unused-vars
import { EMAIL_MESSAGES } from '../../constants/emails.constant';
// eslint-disable-next-line no-unused-vars
import { TASKS, TASK_STATUS_TYPE } from '../../constants/tasks.constant';
import { DOSE_SPOT, DROPDOWN, KIT, KIT_EMAIL, Axena, Eversesnse, Dexcom, Apretude, Vyepti, QUANTITY_RANGE_RESPONSE } from '../../constants/patientChart.constant';
import { IRecoverPassword } from '../../components/recoverPassword/constant';

import { sort, Order, ColumnType } from '../../utils/sortBy';
import { hasAlternateRx as hasAlternateRxInOrder } from '../../utils/alternateRx';
import {
  convertIntoReadableMessage,
  convertIntoReadableMessageV2,
} from '../../utils/emailTemplates';
import { isCancelledOrMedicallyDenied } from '../../utils/productStatus';
import { randomNumber } from '../../utils/random';
import { innerHTMLWithoutFont } from '../../utils/htmlParser';
import { getDateTime } from '../../utils/time';
// eslint-disable-next-line no-unused-vars
import { PATIENT_UPLOADS, DOCUMENT_UPLOADED_IMAGES } from '../../constants/uploads.constant';

const getProductIdForPDFTemplateV1 = ({
  configMap = new Map([['', {}]]),
  info = {},
}) => {
  if(!configMap.has(PID_ProvidersAndCreatePDF)) {
    return { productId: 0 };
  }

  const productMap = (() => {
    try {
      return info.productMap || new Map([['', {}]]);
    } catch(e) {
      return new Map([['', {}]]);
    }
  })();
  const products = configMap.get(PID_ProvidersAndCreatePDF).value;
  if (!products) {
    return { productId: 0 };
  }
  const productIds = products.split(',');
  const foundProductId = productIds.find((id) => productMap.has(Number(id)));
  if (!foundProductId) {
    return { productId: 0 };
  }

  const productId = Number(foundProductId);
  return { productId };
};

/**
 * @description When there is no product id dependency we will use this function.
 */
const getProductIdForPDFTemplateV2 = () => ({ productId: 0 });

const getSFEmailTemplatesWithProductIds = (response = { templateWithProductIds: [IEmailTemplateWithProductId()] }, doctor = { Prefix: '', FirstName: '', LastName: '' }) => {
  const { templateWithProductIds = [] } = response;
  let RANDOM_CONSTANT = 100;

  const valuesCollection = new Map([
    [-1, IEmailTemplateWithProductId()],
  ]);

  const templateCollection = new Map([
    [-1, IEmailTemplate()],
  ]);

  const allTemplates = [];
  let alternateRxProductIndex = -1;
  for (let i = 0; i < templateWithProductIds.length; i++) {
    const product = cloneDeep(templateWithProductIds[i]);
    if (product.productId !== ALTERNATE_RX_PRODUCT_VALUE) {
      allTemplates.push(...product.templateList);
    }
    if (product.productId === ALTERNATE_RX_PRODUCT_VALUE) {
      alternateRxProductIndex = i;
    }
  }

  if (alternateRxProductIndex !== -1) {
    const product = templateWithProductIds[alternateRxProductIndex];
    product.templateList = [...product.templateList, ...allTemplates];
  }

  try {
    for (let i = 0; i < templateWithProductIds.length; i++) {
      const product = templateWithProductIds[i];
      for (let j = 0; j < product.templateList.length; j++) {
        const template = product.templateList[j];
        template.id = RANDOM_CONSTANT++;
        template.pId = product.productId;
        template.title = template.name;
        template.label = template.name;
        template.value = template.id;
        template.body = convertIntoReadableMessageV2(template.body, { doctor: `${doctor.Prefix} ${doctor.FirstName} ${doctor.LastName} ` });
        template.EmailMessageId = template.id;
        template.EmailTemplateTitle = template.name;
        template.EmailTemplateSubject = template.subject;
        template.EmailTemplateBody = template.body;
        template.ProductId = template.pId;
        templateCollection.set(template.id, template);
      }
      valuesCollection.set(product.productId, product);
    }
  } catch(e) {
    // 
  }

  return { templateWithProductIds, templateCollection, valuesCollection };
};

/**
 * @param {{
 *    CreatedDate: string;
 *    createdAtTime: number;
 * }[]} data
 * @returns {{ CreatedDate: string }[]}
 */
const formattedAndSortedTasks = (data) => {
  const formattedData = data.map((task) => {
    const custom = getDateTime({ date_UTC: task.CreatedDate });
    return {
      ...task,
      formattedCreatedAt: `${custom.formatted.date} ${custom.formatted.time}`,
    };
  });
  return sort(formattedData, 'formattedCreatedAt', Order.desc, ColumnType.date);
};

/**
 * @param {*} data 
 * @returns {{
 *  CreatedDate: string;
 *  createdAtTime: number;
 * }[]}
 */
const noCompletedTask = (data) =>
  data.filter((task) => task?.TaskStatus !== TASK_STATUS_TYPE.Complete);

/**
 * @param {{
 *  DateQueueEntered: string;
 * }[]} data 
 */
const sortedAsyncOrders = (data) => {
  return sort(data, 'DateQueueEntered', Order.asc, ColumnType.date);
};

const ProductIdPickerCollection = new Map([
  [Eversesnse, getProductIdForPDFTemplateV1],
  [Axena, getProductIdForPDFTemplateV2],
  [Dexcom, getProductIdForPDFTemplateV1],
  [Apretude, getProductIdForPDFTemplateV1],
  [Vyepti, getProductIdForPDFTemplateV1],
]);

const getPDFTemplate = (info) => {
  const configMap = (() => {
    try {
      return info.StoreFrontData.StorefrontApplicationSettings || new Map([['', {}]]);
    } catch(e) {
      return new Map([['', {}]]);
    }
  })();

  if(!configMap.has(ProvidersAndCreatePDF)) {
    return { template: '', productId: 0 };
  }

  const template = configMap.get(ProvidersAndCreatePDF).value;
  if (!ProductIdPickerCollection.has(template)) {
    return { template: '', productId: 0 };
  }

  const getProductId = ProductIdPickerCollection.get(template);
  const { productId } = getProductId({ configMap, info });
  return { template, productId };
};

const scheduledVisits = () => ({
  filterBy: '',
  lastSyncTime: 0,
  visits: apiData([], false)
});

const asyncOrders = () => ({
  filterBy: '',
  lastSyncTime: 0,
  visits: apiData([], false)
});

const denialAndEmail = () => {
  return {
    emailTemplate: [],
    emailTemplateValue: -1,
    subjectLine: "",
    emailMessage: "",
    denialReasonText: "",
    denialReasonValue: -1,
    denialReason: [],
    denyAndEmailOpen: false,
  };
};

const addNote = () => {
  return {
    orderNoteText: "",
    addPatientNote: false,
    isNoteAdded: false,
    addNoteOpen: false
  };
};

const addSoapNote = () => {
  return {
    orderNoteText: "",
    addPatientNote: false,
    isNoteAdded: false,
    addSoapNoteOpen: false
  };
};

const textPatient = () => {
  return {
    textmessageTemplateData: [],
    textMessageTemplateValue: -1,
    messageValue: "",
    openTextPatient: false,
    isNoteAdded: false,
    textPatient: {
      api: apiData({}),
    },
  };
};

const callPatient = () => ({
  callPatientOpen: false,
  callPatient: {
    api: apiData({}),
  },
});

const sendOrderToCS = () => {
  return {
    sendOrderToCSReason: -1,
    sendOrderToCSNote: "",
    sendOrderToCSOpen: false,
  };
};

const emailPatient = () => {
  return {
    emailTemplate: [],
    emailTemplateValue: -1,
    subjectLine: "",
    emailMessage: "",
    isEmailSentToPatient: false,
    emailPatientOpen: false,
    emailPatient: {
      api: apiData({}),
    },
  };
};

const approvalInfoV2 = () => {
  const _interface = {
    approvalInfoV2: {
      kitsCollection: KIT(),
      api: apiData([]),
    },
  };
  _interface.approvalInfoV2.kitsCollection.delete('');
  return _interface;
};

const approveAndMailData = () => {
  return {
    approveAndMailData: [],
    emailTemplate: [],
    emailTemplateValue: -1,
    subjectLine: "",
    emailMessage: "",
    approveAndMailPin: "",
    orderAndPrescriberFlag: ORDER_AND_PRESCRIBER_FLAGS(),
    approvalOrderFlagValue: [],
    approvalPrescriberFlagValue: [],
    approvalPinError: "",
    approveAndSendEmailOpen: false,
    doseSpotData: DOSE_SPOT(),
  };
};

const reference = () => ({
  commonModal: new Set(),
});

const callSummaryReasons = () => ({
  callSummary: {
    value: -1,
    reasons: []
  }
});

const getPdf = () => ({
  orderId: 0,
  api: apiData({}),
});

const cmnTemplateFormField = () => ({
  cmnTemplateFormField: {
    ...DEFAULT_FORMFIELD,
  }
});

const soapNoteTemplates = () => ({
  soapNoteTemplates: {
    value: -1,
    valuesCollection: new Map([[-1, DROPDOWN()]]),
    api: apiData(),
  },
});

const patientUploads = () => ({
  patientUploads: {
    valuesCollection: new Map(),
    api: apiData(),
  }
});

const changeProducts = () => ({
  changeProducts: {
    api: apiData(new Map()),
  },
});

const emailTemplatesV2 = () => ({
  emailTemplatesV2: {
    templateCollection: new Map([
      [-1, IEmailTemplate()],
    ]),
    valuesCollection: new Map([
      [-1, IEmailTemplateWithProductId()],
    ]),
    api: apiData([]),
  },
});

const approveEmailTemplatesV2 = () => ({
  approveEmailTemplatesV2: {
    templateCollection: new Map([
      [-1, IEmailTemplate()],
    ]),
    valuesCollection: new Map([
      [-1, IEmailTemplateWithProductId()],
    ]),
    api: apiData([]),
  },
});

const denyEmailTemplatesV2 = () => ({
  denyEmailTemplatesV2: {
    templateCollection: new Map([
      [-1, IEmailTemplate()],
    ]),
    valuesCollection: new Map([
      [-1, IEmailTemplateWithProductId()],
    ]),
    api: apiData([]),
  },
});

const emailSubjects = () => ({
  emailSubjects: {
    api: apiData(new Map()),
  }
});

const emailReasons = () => ({
  emailReasons: {
    valuesCollection: new Map([
      [0, emailReason()],
    ]),
    api: apiData([]),
  },
});

const emailMessages = () => ({
  emailMessages: {
    api: apiData([]),
  },
});

const consultQuestion = () => {
  const _interface = {
    consultQuestion: {
      api: apiData({}),
      OrderId: 0,
      ProductConsultDetails: [],
      consultIds: new Set([0]),
      consultId: 0,
    }
  };
  _interface.consultQuestion.consultIds.delete(0);
  return _interface;
};

const productInfoCache = () => ({
  productInfoCache: new Map([
    ['', productInfo().productInfo]
  ]),
  loadingProductInfoCacheForOrderId: new Set(['']),
});

const productCost = () => ({
  productCost: {
    api: apiData({
      ProductCost: 0,
      ProductShippingCost: 0,
      ProductTax: 0,
      Productdiscount: 0,
      TotalOrderCost: 0,
    }),
  }
});

const orderAndPrescriberFlagsV2 = () => ({
  orderAndPrescriberFlagsV2: ORDER_AND_PRESCRIBER_FLAGS(),
});

const criticalFlags = () => ({
  criticalFlags: CRITICAL_FLAGS(),
});

const doctorFlags = () => ({
  doctorFlags: DOCTOR_FLAGS(),
});

const savedFlags = () => ({
  savedFlags: SAVED_FLAGS(),
});

const saveFlags = () => ({
  saveFlags: {
    api: apiData({}),
  },
});

const orders = () => {
  const _interface = {
    orders: ORDERS(),
  };
  _interface.orders.scheduled.collection.delete(0);
  _interface.orders._async.collection.delete(0);
  _interface.orders.all.collection.delete(0);
  return _interface;
};

const saveExtendedConsult = () => ({
  saveExtendedConsult: {
    api: apiData({}),
  },
});

const orderNotesAPI = () => ({
  orderNotesAPI: apiData({})
});

const patientNotesAPI = () => ({
  patientNotesAPI: apiData({})
});

const medicalOrderNotesAPI = () => ({
  medicalOrderNotesAPI: apiData({})
});

const medicalPatientNotesAPI = () => ({
  medicalPatientNotesAPI: apiData({})
});

const historyAPI = () => ({
  historyAPI: apiData([]),
});

const recoverPassword = () => ({
  recoverPassword: IRecoverPassword(),
});

const quantityRangeForProduct = () => ({
  quantityRangeForProduct: QUANTITY_RANGE_RESPONSE(),
});

const changeProductForOrderAPI = () => ({
  changeProductForOrderAPI: apiData({}),
});

const searchOrdersAPI = () => ({
  searchOrdersAPI: apiData({}),
});

const headerInfoAPI = () => ({
  headerInfoAPI: apiData({}),
});

const tasksInfo = () => ({
  tasksInfo: {
    ...apiData([]),
    lastSyncTime: 0,
  },
});

const tasksInfoByOrderId = () => ({
  tasksInfoByOrderId: apiData([]),
});

const icd10CodesByTerms = () => ({
  icd10CodesByTerms: apiData({
    count: 0,
    icd10Codes: [],
    error: null,
    icd10CodesWithDescription: [],
    icd10CodesCollection: new Map(),
  }),
});

const addICD10CodesAPI = () => ({
  addICD10CodesAPI: apiData({}),
});

const removeICD10CodesAPI = () => ({
  removeICD10CodesAPI: apiData({}),
});

const changePasswordAPI = () => ({
  changePasswordAPI: apiData({}),
});

/**
 * @returns {{
 *  icd10CodesByOrderId: {
 *    data: {
 *      icd10Codes: {
 *        Id: number;
 *        ICDCode: string;
 *        ICDDesc: string;
 *      }[];
 *      recommendedCodes: {
 *        Id: number;
 *        ICDCode: string;
 *        ICDDesc: string;
 *      }[];
 *      icd10CodesCollection: Map<string, {
 *        Id: number;
 *        ICDCode: string;
 *        ICDDesc: string;
 *      }>;
 *    };
 *    called: boolean;
 *    loading: boolean;
 *  }
 * }}
 */
const icd10CodesByOrderId = () => ({
  icd10CodesByOrderId: apiData({
    icd10Codes: [],
    recommendedCodes: [],
    icd10CodesCollection: new Map(),
  }),
});

const icd10CodesByPatientId = () => ({
  icd10CodesByPatientId: apiData([]),
});

const initialState = () => {
  return {
    subscribed: localStorage.getItem("user") ? true : false,
    modalOpen: false,
    selectedPrescriberInfo: {},
    searchData: [],
    searchError: "",

    //schedulevisits
    ...productInfo(),
    ...productInfoCache(),
    callDetailSent: false,
    selectedTab: 0,
    ...patientInfo(),
    notes: [],
    productList: {},
    qtyByProduct: void 0,
    productListModalError: "",
    isProductChangeModalOpen: false,
    ...consultQuestion(),
    orderNotes: {},
    patientNotes: {},
    medicalOrderNotes: {},
    medicalPatientNotes: {},
    soapNoteInfo: false,
    emailData: [],
    historyData: [],
    ...historyAPI(),
    sendOrderToCSReasons: [],
    errorModalOpen: "",
    isModalAlertOpen: false,
    isModalTwilioAlertOpen: false,
    callStarted: false,
    callToPatientStatus: false,
    approveAndEmailDone: false,
    isVideoFocused: false,
    isDoseSpotError: false,
    isDoseSpotErrorModalOpen: false,
    loggedOff: false,
    uploadedDocs: [],
    uploadedPdfs: [],
    pdfExists: false,
    getPdf: getPdf(),
    ...denialAndEmail(),
    ...approvalInfoV2(),
    ...approveAndMailData(),
    ...addNote(),
    ...addSoapNote(),
    ...sendOrderToCS(),
    ...emailPatient(),
    ...textPatient(),
    ...callPatient(),
    reference: reference(),
    ...callSummaryReasons(),
    ...cmnTemplateFormField(),
    ...soapNoteTemplates(),
    ...patientUploads(),
    ...changeProducts(),
    ...emailSubjects(),
    ...emailReasons(),
    ...productCost(),
    ...addProductInfo(),
    ...emailTemplatesV2(),
    ...approveEmailTemplatesV2(),
    ...denyEmailTemplatesV2(),
    ...orderAndPrescriberFlagsV2(),
    ...criticalFlags(),
    ...doctorFlags(),
    ...savedFlags(),
    ...saveFlags(),
    ...saveExtendedConsult(),
    ...emailMessages(),
    ...quantityRangeForProduct(),

    scheduledVisits: scheduledVisits(),
    asyncOrders: asyncOrders(),
    ...orders(),

    ...orderNotesAPI(),
    ...patientNotesAPI(),
    ...medicalOrderNotesAPI(),
    ...medicalPatientNotesAPI(),
    ...changeProductForOrderAPI(),
    ...searchOrdersAPI(),
    ...headerInfoAPI(),

    ...recoverPassword(),

    ...tasksInfo(),
    ...tasksInfoByOrderId(),
    ...icd10CodesByTerms(),
    ...icd10CodesByOrderId(),
    ...icd10CodesByPatientId(),
    ...addICD10CodesAPI(),
    ...removeICD10CodesAPI(),
    
    ...changePasswordAPI(),
  };
};

const userReducer = (state = initialState(), action = {}) => {
  let errorMessage =
    action.error && action.error.data && action.error.data.Error;
  let connectionError =
    action.error && action.error.data && action.error.data.connectionError;
  switch (action.type) {
    case RESET_APP_STATE: {
      return {
        ...state,
        ...initialState(),
      };
    }
    case RESET_PATIENT_INFO: {
      return {
        ...state,
        ...productInfo(),
        ...productInfoCache(),
        ...patientInfo(),
        ...changeProducts(),
        notes: [],
        productList: {},
        qtyByProduct: void 0,
        productListModalError: "",
        isProductChangeModalOpen: false,
        ...consultQuestion(),
        orderNotes: {},
        patientNotes: {},
        soapNoteInfo: true,
        selectedTab: 0,
        emailData: [],
        historyData: [],
        ...historyAPI(),
        errorModalOpen: "",
        isModalAlertOpen: false,
        callStarted: false,
        callPatientDetails: {},
        approveAndEmailDone: false,
        denyAndEmailDone: false,
        sendOrderToCSDone: false,
        isVideoFocused: false,
        callDetailSent: false,
        isDoseSpotError: false,
        isDoseSpotErrorModalOpen: false,
        loggedOff: false,
        ...denialAndEmail(),
        ...approvalInfoV2(),
        ...approveAndMailData(),
        ...addNote(),
        ...addSoapNote(),
        ...sendOrderToCS(),
        ...emailPatient(),
        ...textPatient(),
        ...callPatient(),
        ...emailSubjects(),
        ...emailReasons(),
        reference: reference(),
        ...callSummaryReasons(),
        ...cmnTemplateFormField(),
        ...productCost(),
        ...addProductInfo(),
        ...emailTemplatesV2(),
        ...approveEmailTemplatesV2(),
        ...denyEmailTemplatesV2(),
        ...orderAndPrescriberFlagsV2(),
        ...criticalFlags(),
        ...doctorFlags(),
        ...savedFlags(),
        ...saveFlags(),
        ...saveExtendedConsult(),
        ...emailMessages(),
        ...orderNotesAPI(),
        ...patientNotesAPI(),
        ...medicalOrderNotesAPI(),
        ...medicalPatientNotesAPI(),
        ...quantityRangeForProduct(),
        ...changeProductForOrderAPI(),
        ...searchOrdersAPI(),
        ...headerInfoAPI(),
        ...tasksInfo(),
        ...tasksInfoByOrderId(),
        ...icd10CodesByTerms(),
        ...icd10CodesByOrderId(),
        ...icd10CodesByPatientId(),
      };
    }

    case RESET_EMAIL_AND_DENY_DATA: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...denialAndEmail(),
        ...emailTemplatesV2(),
        ...approveEmailTemplatesV2(),
        ...denyEmailTemplatesV2(),
      };
    }

    case RESET_ADD_NOTE_DATA: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...addNote(),
        ...addSoapNote(),
      };
    }

    case RESET_SEND_ORDER_TO_CS_DATA: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...sendOrderToCS(),
      };
    }

    case RESET_TEXT_PATIENT: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...textPatient(),
      };
    }

    case HANDLE_GLOBAL_VALUE_CHANGE: {
      const { reference } = state;
      const { name, value, type } = action.data;
      let nextState = { ...state };

      if (type !== 'commonModal') {
        return {
          ...nextState,
          [name]: value,
        };
      }

      if (!value) {
        reference.commonModal.delete(name);
        nextState = {
          ...nextState,
          [name]: value,
        };
      }

      const hasCommonModal = reference.commonModal.size > 0;
      if (value && !hasCommonModal) {
        reference.commonModal.add(name);
        nextState = {
          ...nextState,
          [name]: value,
        }
      }

      return nextState;
    }

    case CHECK_DOSESPOT: {
      let isDoseSpotError = action.data.ResponseCode < 0;
      let isDoseSpotErrorModalOpen = isDoseSpotError && action.data.StringValue;
      return {
        ...state,
        isDoseSpotError: isDoseSpotError,
        isDoseSpotErrorModalOpen,
      };
    }

    case RESET_EMAIL_PATIENT_DATA: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...emailPatient(),
        ...emailTemplatesV2(),
        ...approveEmailTemplatesV2(),
        ...denyEmailTemplatesV2(),
      };
    }
    case GET_TEXT_PATIENT_TEMPLATE: {
      return {
        ...state,
        textmessageTemplateData: action?.data || [],
      };
    }

    case APPROVE_AND_MAIL_SUBMIT: {
      const commonModal = 'approveAndSendEmailOpen';
      const { reference } = state;
      reference.commonModal.delete(commonModal);

      return {
        ...state,
        approveAndEmailDone: true,
        [commonModal]: false,
      };
    }

    case RESET_DOSESPOT_DATA: {
      return {
        ...state,
        doseSpotData: DOSE_SPOT(),
      };
    }

    case GET_DOSESPOT_DATA: {
      return {
        ...state,
        doseSpotData: { ...action.data, openCommonModal: true },
      };
    }

    case TEXT_PATIENT_LOADING: {
      const { textPatient } = state;
      return {
        ...state,
        textPatient: {
          ...textPatient,
          api: apiData(textPatient.api.data, true, true),
        },
      };
    }

    case TEXT_PATIENT_FALIURE: {
      const { textPatient } = state;
      let type = true;
      if (connectionError) {
        type = errorMessage;
      }
      return {
        ...state,
        isModalAlertOpen: type,
        textPatient: {
          ...textPatient,
          api: apiData(textPatient.api.data, false, true),
        },
      };
    }

    case TEXT_PATIENT: {
      const commonModal = 'openTextPatient';
      const { reference, textPatient } = state;
      reference.commonModal.delete(commonModal);

      return {
        ...state,
        [commonModal]: false,
        isNoteAdded: true,
        textPatient: {
          ...textPatient,
          api: apiData(textPatient.api.data, false, true),
        },
      };
    }

    case POST_CALL_DETAILS: {
      return {
        ...state,
        callDetailSent: action.data,
      };
    }

    case RESET_APPROVE_AND_MAIL_DATA: {
      return {
        ...state,
        errorModalOpen: "",
        isModalAlertOpen: false,
        ...approvalInfoV2(),
        ...approveAndMailData(),
        ...orderAndPrescriberFlagsV2(),
        ...criticalFlags(),
        ...doctorFlags(),
        ...savedFlags(),
        ...saveFlags(),
      };
    }
    case SET_START_VISIT: {
      if (!action.data) {
        return {
          ...state,
          callStarted: action.data,
          callDetailSent: false,
        };
      }
      return {
        ...state,
        callStarted: action.data,
      };
    }

    case TOGGLE_MODAL: {
      return {
        ...state,
        modalOpen: action.data,
      };
    }

    case RESET_NOTES_TAB: {
      return {
        ...state,
        medicalOrderNotes: {},
        medicalPatientNotes: {},
        orderNotes: {},
        patientNotes: {},
      };
    }

    case RESET_EMAIL_TAB: {
      return {
        ...state,
        ...emailMessages(),
        emailData: [],
      };
    }

    case RESET_HISTROY_TAB: {
      return {
        ...state,
        historyData: [],
        ...historyAPI(),
      };
    }

    case SET_MODAL_ALERT_OPEN: {
      return {
        ...state,
        isModalAlertOpen: action.data,
      };
    }
    case TOGGLE_ERROR_MODAL: {
      return {
        ...state,
        errorModalOpen: action.data,
      };
    }
    case SET_APPROVE_AND_MAIL_DATA: {
      return {
        ...state,
        approveAndMailData: action.data,
      };
    }
    case SET_ADD_NOTE:
    case SET_ADD_SOAP_NOTE:
    case SET_DENIAL_AND_SEND_EMAIL:
    case SET_SEND_ORDER_TO_CS_DATA: {
      return {
        ...state,
        [action.data.name]: action.data.value,
      };
    }
    case SET_APPROVE_AND_MAIL_MAIN_DATA: {
      return {
        ...state,
        [action.name]: action.data,
      };
    }
    case SET_SELECTED_TAB: {
      return {
        ...state,
        selectedTab: action.data,
      };
    }

    case RESET_APPROVE_AND_EMAIL_PRESCRIER_INFO: {
      return {
        ...state,
        ...approvalInfoV2(),
        doseSpotData: DOSE_SPOT(),
      };
    }
    case GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_LOADING: {
      const { approvalInfoV2 } = state;
      return {
        ...state,
        approvalInfoV2: {
          ...approvalInfoV2,
          api: apiData(approvalInfoV2.api.data, true, true),
        },
      };
    }
    case GET_APPROVE_AND_EMAIL_PRESCRIER_INFO: {
      const { approvalInfoV2 } = state;
      const approveAndMailData = action.data;

      const kitsCollection = KIT();
      kitsCollection.delete('');

      for (let i = 0; i < approveAndMailData.length; i++) {
        try {
          const item = cloneDeep(approveAndMailData[i]);

          if (item?.Refills?.RefillOptions?.length > 0) {
            item.Refills.RefillOptions = item.Refills.RefillOptions.map((value) => ({
              id: `${value}`,
              value: `${value}`,
              label: `${value}`,
              description: `${value}`,
            }));
          }

          let kitKey = `product-only-${i}`;
          let kitPId = 0;
          if (item?.ProductIdForKit !== 0) {
            kitKey = `kit-${item.ProductIdForKit}`;
            kitPId = item.ProductIdForKit;
          }

          if (!kitsCollection.has(kitKey)) {
            kitsCollection.set(kitKey, { kitPId, items: [], email: KIT_EMAIL(), });
          }

          const kit = kitsCollection.get(kitKey);
          kit.items.push(item);
        } catch(e) {

        }

        if (typeof approveAndMailData[i] === "object") {
          approveAndMailData[i].orgSig = approveAndMailData[i].Sig;
        }
      }

      return {
        ...state,
        approveAndMailData,
        approvalInfoV2: {
          ...approvalInfoV2,
          kitsCollection,
          api: apiData(action.data || [], false, true),
        },
      };
    }
    case GET_APPROVE_AND_EMAIL_PRESCRIER_INFO_FAILURE: {
      const { approvalInfoV2 } = state;
      let type = true;
      if (connectionError) {
        type = errorMessage;
      }
      return {
        ...state,
        isModalAlertOpen: type,
        approvalInfoV2: {
          ...approvalInfoV2,
          api: apiData(approvalInfoV2.api.data, false, true),
        },
      };
    }

    case GET_ORDER_AND_PRESCRIBER_FLAGS_LOADING: {
      return {
        ...state,
        orderAndPrescriberFlagsV2: {
          ...state.orderAndPrescriberFlagsV2,
          api: apiData(state.orderAndPrescriberFlagsV2.api.data, true, true),
        }
      };
    }
    case GET_ORDER_AND_PRESCRIBER_FLAGS: {
      const defaultFlags = ORDER_AND_PRESCRIBER_FLAGS();
      return {
        ...state,
        orderAndPrescriberFlag: action.data,
        orderAndPrescriberFlagsV2: {
          ...state.orderAndPrescriberFlagsV2,
          api: apiData(action?.data || defaultFlags.api.data, false, true),
        }
      };
    }
    case GET_ORDER_AND_PRESCRIBER_FLAGS_FAILURE: {
      let type = true;
      if (connectionError) {
        type = errorMessage;
      }
      return {
        ...state,
        isModalAlertOpen: type,
        orderAndPrescriberFlagsV2: {
          ...state.orderAndPrescriberFlagsV2,
          api: apiData(state.orderAndPrescriberFlagsV2.api.data, false, true),
        }
      };
    }
    case RESET_ORDER_AND_PRESCRIBER_FLAGS: {
      return {
        ...state,
        ...orderAndPrescriberFlagsV2(),
        ...criticalFlags(),
        ...doctorFlags(),
      };
    }
    case GET_HISTORY_LOADING: {
      const { historyAPI } = state;
      return {
        ...state,
        historyAPI: apiData(historyAPI.data, true, true),
      };
    }
    case GET_HISTORY: {
      const { historyAPI } = state;
      const data = action?.data || [];

      for (let i = 0; i < data.length; i++) {
        const products = data[i].Products;

        for (let j = 0; j < products.length; j++) {
          products[j].displayTitle = products[j].PrescriberProductDisplayName || products[j].ProductTitle;
        }
      }

      return {
        ...state,
        historyData: data,
        historyAPI: apiData(historyAPI.data, false, true),
      };
    }
    case GET_HISTORY_FALIURE: {
      const { historyAPI } = state;
      return {
        ...state,
        errorModalOpen: errorMessage,
        historyAPI: apiData(historyAPI.data, false, true),
      };
    }

    case DENIAL_AND_EMAIL: {
      const commonModal = 'denyAndEmailOpen';
      const { reference } = state;
      reference.commonModal.delete(commonModal);

      return {
        ...state,
        denyAndEmailDone: true,
        [commonModal]: false,
      };
    }

    case SEND_ORDER_TO_CS: {
      return {
        ...state,
        sendOrderToCSOpen: false,
        sendOrderToCSDone: true,
      };
    }
    case ADD_NOTE: {
      return {
        ...state,
        isNoteAdded: true,
      };
    }

    case ADD_SOAP_NOTE: {
      return {
        ...state,
        isNoteAdded: true,
      };
    }

    case GET_PENDING_FILES_CARD_LOADING: {
      return {
        ...state,
        asyncOrders: {
          ...state.asyncOrders,
          visits: apiData(state.asyncOrders.visits.data, true, true)
        }
      };
    }
    case GET_PENDING_FILES_CARD: {
      const { data: visits = [] } = action;
      const { orders: { _async, all } } = state;
      const asyncCollection = new Map(_async.collection);
      const allCollection = new Map(all.collection);

      for (let i = 0; i < visits.length; i++) {
        const visit = visits[i];
        asyncCollection.set(visit.OrderId, visit);
        allCollection.set(visit.OrderId, visit);
      }

      const sortedData = sortedAsyncOrders(action.data || []);

      return {
        ...state,
        asyncOrders: {
          ...state.asyncOrders,
          lastSyncTime: new Date().getTime(),
          visits: apiData(sortedData, false, true)
        },
        orders: {
          ...state.orders,
          _async: {
            ..._async,
            collection: asyncCollection,
          },
          all: {
            ...all,
            collection: allCollection,
          },
        },
      };
    }
    case GET_PENDING_FILES_CARD_CLEAR_API_STATUS: {
      return {
        ...state,
        asyncOrders: {
          ...state.asyncOrders,
          lastSyncTime: 0,
          visits: apiData(state.asyncOrders.visits.data)
        }
      };
    }
    case GET_PENDING_FILES_CARD_FALIURE: {
      return {
        ...state,
        asyncOrders: {
          ...state.asyncOrders,
          lastSyncTime: new Date().getTime(),
          visits: apiData(state.asyncOrders.visits.data, false, true)
        },
        errorModalOpen: errorMessage,
      };
    }
    case TOGGLE_PRODUCT_CHANGE_MODAL: {
      return {
        ...state,
        isProductChangeModalOpen: action.data,
        productListModalError: "",
      };
    }
    case GET_PRODUCT_LIST: {
      let ProductItem = (() => {
        try {
          return action.data.ProductItem || [];
        } catch(e) {
          return [];
        }
      })();
      for (let i = 0; i < ProductItem.length; i++) {
        const product = { ...ProductItem[i] };
        ProductItem[i].displayTitle = product.PrescriberProductDisplayName || product.Title;
      }

      return {
        ...state,
        productList: { ProductItem },
      };
    }
    case GET_SCHEDULE_VISITS_CARD_LOADING: {
      return {
        ...state,
        scheduledVisits: {
          ...state.scheduledVisits,
          visits: apiData(state.scheduledVisits.visits.data, true, true)
        }
      };
    }
    case GET_SCHEDULE_VISITS_CARD_CLEAR_API_STATUS: {
      return {
        ...state,
        scheduledVisits: {
          ...state.scheduledVisits,
          lastSyncTime: 0,
          visits: apiData(state.scheduledVisits.visits.data)
        }
      };
    }
    case GET_SCHEDULE_VISITS_CARD: {
      const { data: visits = [] } = action;
      const { orders: { scheduled, all } } = state;
      const scheduledCollection = new Map(scheduled.collection);
      const allCollection = new Map(all.collection);

      for (let i = 0; i < visits.length; i++) {
        const visit = visits[i];
        scheduledCollection.set(visit.OrderId, visit);
        allCollection.set(visit.OrderId, visit);
      }

      return {
        ...state,
        scheduledVisits: {
          ...state.scheduledVisits,
          lastSyncTime: new Date().getTime(),
          visits: apiData(visits, false, true)
        },
        orders: {
          ...state.orders,
          scheduled: {
            ...scheduled,
            collection: scheduledCollection,
          },
          all: {
            ...all,
            collection: allCollection,
          },
        },
      };
    }

    case REMOVE_ORDERS_FROM_LV: {
      const { data: { orderIds = [] } } = action;
      const { orders: { scheduled, _async, all } } = state;
      const scheduledCollection = new Map(scheduled.collection);
      const asyncCollection = new Map(_async.collection);
      const allCollection = new Map(all.collection);

      try {
        for (let i = 0; i < orderIds?.length; i++) {
          const orderId = Number(orderIds[i]);
          scheduledCollection.delete(orderId);
          asyncCollection.delete(orderId);
          allCollection.delete(orderId);
        }
      } catch (e) {

      }

      return {
        ...state,
        orders: {
          ...state.orders,
          scheduled: {
            ...scheduled,
            collection: scheduledCollection,
          },
          _async: {
            ..._async,
            collection: asyncCollection,
          },
          all: {
            ...all,
            collection: allCollection,
          },
        },
      };
    }

    case GET_CONSULT_QUESTION_LOADING: {
      return {
        ...state,
        consultQuestion: {
          ...state.consultQuestion,
          api: apiData(state.consultQuestion.api.data, true, true),
        },
      };
    }
    case GET_CONSULT_QUESTION: {
      const { ProductConsultDetails: products = [] } = action.data;
      // const { ProductConsultDetails: products = [] } = CONSULT_WITH_QUESTIONS;
      const questionAnswers = (products || []).flatMap(({ QuestionAnswers }) => (QuestionAnswers || []));

      const consultIds = new Set([0]);
      consultIds.delete(0);

      for (let i = 0; i < questionAnswers.length; i++) {
        const { ConsultId } = questionAnswers[i];
        if (ConsultId) {
          consultIds.add(ConsultId);
        }
      }

      let consultId = 0;
      if (consultIds.size === 1) {
        consultId = [...consultIds.values()].at(0);
      }

      return {
        ...state,
        consultQuestion: {
          ...state.consultQuestion,
          ...action.data,
          // ...CONSULT_WITH_QUESTIONS,
          consultIds,
          consultId,
          api: apiData(state.consultQuestion.api.data, false, true),
        },
      };
    }
    case GET_CONSULT_QUESTION_FALIURE: {
      return {
        ...state,
        consultQuestion: {
          ...state.consultQuestion,
          api: apiData(state.consultQuestion.api.data, false, true),
        },
        errorModalOpen: errorMessage,
      };
    }

    case GET_ORDER_NOTES_LOADING: {
      const { orderNotesAPI } = state;
      return {
        ...state,
        orderNotesAPI: { ...orderNotesAPI, called: true, loading: true },
      };
    }
    case GET_ORDER_NOTES: {
      const { orderNotesAPI } = state;
      return {
        ...state,
        orderNotes: action.data,
        orderNotesAPI: { ...orderNotesAPI, called: true, loading: false },
      };
    }
    case GET_ORDER_NOTES_FAILURE: {
      const { orderNotesAPI } = state;
      return {
        ...state,
        errorModalOpen: errorMessage,
        orderNotesAPI: { ...orderNotesAPI, called: true, loading: false },
      };
    }

    case GET_EMAIL_TEMPLATE: {
      return {
        ...state,
        emailTemplate: action.data,
      };
    }

    case GET_EMAIL_TEMPLATE_V2_LOADING: {
      const { emailTemplatesV2 } = state;
      return {
        ...state,
        emailTemplatesV2: {
          ...emailTemplatesV2,
          api: apiData(emailTemplatesV2.api.data, true, true),
        }
      };
    }

    case GET_EMAIL_TEMPLATE_V2: {
      const { selectedPrescriberInfo } = state;
      const { valuesCollection, templateCollection, templateWithProductIds } = getSFEmailTemplatesWithProductIds(action?.data || DefaultSFEmailTemplatesResponse, selectedPrescriberInfo);
      return {
        ...state,
        emailTemplatesV2: {
          valuesCollection,
          templateCollection,
          api: apiData(templateWithProductIds, false, true),
        },
      };
    }

    case GET_EMAIL_TEMPLATE_V2_FAILURE: {
      const { emailTemplatesV2 } = state;
      // const { selectedPrescriberInfo } = state;
      // const { valuesCollection, templateCollection, templateWithProductIds } = getSFEmailTemplatesWithProductIds(SF_EMAIL_TEMPLATES_RESPONSE, selectedPrescriberInfo);
      return {
        ...state,
        emailTemplatesV2: {
          ...emailTemplatesV2,
          api: apiData(emailTemplatesV2.api.data, false, true),
          // valuesCollection,
          // templateCollection,
          // api: apiData(templateWithProductIds, false, true),
        }
      };
    }

    case GET_APPROVE_EMAIL_TEMPLATE_V2_LOADING: {
      const { approveEmailTemplatesV2 } = state;
      return {
        ...state,
        approveEmailTemplatesV2: {
          ...approveEmailTemplatesV2,
          api: apiData(approveEmailTemplatesV2.api.data, true, true),
        }
      };
    }

    case GET_APPROVE_EMAIL_TEMPLATE_V2: {
      const { selectedPrescriberInfo } = state;
      const { valuesCollection, templateCollection, templateWithProductIds } = getSFEmailTemplatesWithProductIds(action?.data || DefaultSFEmailTemplatesResponse, selectedPrescriberInfo);
      return {
        ...state,
        approveEmailTemplatesV2: {
          valuesCollection,
          templateCollection,
          api: apiData(templateWithProductIds, false, true),
        },
      };
    }

    case GET_APPROVE_EMAIL_TEMPLATE_V2_FAILURE: {
      const { approveEmailTemplatesV2 } = state;
      return {
        ...state,
        approveEmailTemplatesV2: {
          ...approveEmailTemplatesV2,
          api: apiData(approveEmailTemplatesV2.api.data, false, true),
        }
      };
    }

    case GET_DENY_EMAIL_TEMPLATE_V2_LOADING: {
      const { denyEmailTemplatesV2 } = state;
      return {
        ...state,
        denyEmailTemplatesV2: {
          ...denyEmailTemplatesV2,
          api: apiData(denyEmailTemplatesV2.api.data, true, true),
        }
      };
    }

    case GET_DENY_EMAIL_TEMPLATE_V2: {
      const { selectedPrescriberInfo } = state;
      const { valuesCollection, templateCollection, templateWithProductIds } = getSFEmailTemplatesWithProductIds(action?.data || DefaultSFEmailTemplatesResponse, selectedPrescriberInfo);
      return {
        ...state,
        denyEmailTemplatesV2: {
          valuesCollection,
          templateCollection,
          api: apiData(templateWithProductIds, false, true),
        },
      };
    }

    case GET_DENY_EMAIL_TEMPLATE_V2_FAILURE: {
      const { denyEmailTemplatesV2 } = state;
      // const { valuesCollection, templateCollection, templateWithProductIds } = getSFEmailTemplatesWithProductIds(SF_EMAIL_TEMPLATES_RESPONSE, selectedPrescriberInfo);
      return {
        ...state,
        denyEmailTemplatesV2: {
          ...denyEmailTemplatesV2,
          api: apiData(denyEmailTemplatesV2.api.data, false, true),
          // valuesCollection,
          // templateCollection,
          // api: apiData(templateWithProductIds, false, true),
        }
      };
    }

    case VERIFY_PIN: {
      if (action.data === "Valid PIN") {
        return {
          ...state,
          approvalPinError: "",
        };
      } else {
        return {
          ...state,
          approvalPinError: action.data,
          approveAndMailPin: "",
        };
      }
    }

    case GET_SUB_AND_EMAIL: {
      return {
        ...state,
        subjectLine: action.data.EmailTemplateSubject,
        emailMessage: convertIntoReadableMessage(action.data.EmailTemplateBody, { doctor: '' }),
      };
    }

    case GET_SUB_AND_EMAIL_V2: {
      const { emailTemplatesV2: { templateCollection } } = state;
      const { data } = action;

      if (!templateCollection.has(data.messageId)) {
        return { ...state };
      }

      const template = templateCollection.get(data.messageId);
      return {
        ...state,
        subjectLine: template.EmailTemplateSubject,
        emailMessage: convertIntoReadableMessage(template.EmailTemplateBody, { doctor: '' }),
      };
    }

    case RESET_SUB_AND_EMAIL_V2: {
      const { emailTemplateValue, subjectLine, emailMessage, emailTemplatesV2: { templateCollection }} = state;
      const { data } = action;

      const emailTemplateData = {
        emailTemplateValue,
        subjectLine,
        emailMessage,
      };

      const template = templateCollection.get(emailTemplateData.emailTemplateValue);
      if (data.pId === template.pId) {
        emailTemplateData.emailTemplateValue = -1;
        emailTemplateData.subjectLine = '';
        emailTemplateData.emailMessage = '';
      }

      return {
        ...state,
        ...emailTemplateData,
      };
    }

    case GET_DENIAL_REASON: {
      return {
        ...state,
        denialReason: action?.data || [],
      };
    }

    case GET_PATIENT_NOTES_LOADING: {
      const { patientNotesAPI } = state;
      return {
        ...state,
        patientNotesAPI: { ...patientNotesAPI, called: true, loading: true },
      };
    }
    case GET_PATIENT_NOTES: {
      const { patientNotesAPI } = state;
      return {
        ...state,
        patientNotes: action.data,
        patientNotesAPI: { ...patientNotesAPI, called: true, loading: false },
      };
    }
    case GET_PATIENT_NOTES_FAILURE: {
      const { patientNotesAPI } = state;
      return {
        ...state,
        errorModalOpen: errorMessage,
        patientNotesAPI: { ...patientNotesAPI, called: true, loading: false },
      };
    }

    case GET_MEDICAL_ORDER_NOTES_LOADING: {
      const { medicalOrderNotesAPI } = state;
      return {
        ...state,
        medicalOrderNotesAPI: { ...medicalOrderNotesAPI, called: true, loading: true },
      };
    }
    case GET_MEDICAL_ORDER_NOTES: {
      const { medicalOrderNotesAPI } = state;
      return {
        ...state,
        medicalOrderNotes: action.data,
        medicalOrderNotesAPI: { ...medicalOrderNotesAPI, called: true, loading: false },
      };
    }
    case GET_MEDICAL_ORDER_NOTES_FAILURE: {
      const { medicalOrderNotesAPI } = state;
      return {
        ...state,
        errorModalOpen: errorMessage,
        medicalOrderNotesAPI: { ...medicalOrderNotesAPI, called: true, loading: false },
      };
    }

    case GET_MEDICAL_PATIENT_NOTES_LOADING: {
      const { medicalPatientNotesAPI } = state;
      return {
        ...state,
        medicalPatientNotesAPI: { ...medicalPatientNotesAPI, called: true, loading: true },
      };
    }
    case GET_MEDICAL_PATIENT_NOTES: {
      const { medicalPatientNotesAPI } = state;
      return {
        ...state,
        medicalPatientNotes: action.data,
        medicalPatientNotesAPI: { ...medicalPatientNotesAPI, called: true, loading: false },
      };
    }
    case GET_MEDICAL_PATIENT_NOTES_FAILURE: {
      const { medicalPatientNotesAPI } = state;
      return {
        ...state,
        errorModalOpen: errorMessage,
        medicalPatientNotesAPI: { ...medicalPatientNotesAPI, called: true, loading: false },
      };
    }

    case GET_SOAP_NOTE_INFO: {
      return {
        ...state,
        soapNoteInfo: action.data,
      };
    }
    case GET_NOTES: {
      const { DoctorNotes = [], CriticalNotes = [] } = action?.data || { DoctorNotes: [], CriticalNotes: [] };
      const cFlags = (() => {
        if (!CriticalNotes?.length) {
          return [];
        }
        return CriticalNotes.map(({ NoteText, Required }) => ({
          flagId: randomNumber(),
          flagText: innerHTMLWithoutFont(NoteText),
          required: !!Required,
        }));
      })();

      const dFlags = (() => {
        if (!DoctorNotes?.length) {
          return [];
        }
        return DoctorNotes.map(({ NoteText, Required }) => ({
          flagId: randomNumber(),
          flagText: innerHTMLWithoutFont(NoteText),
          required: !!Required,
        }));
      })();

      return {
        ...state,
        notes: [...DoctorNotes, ...CriticalNotes],
        criticalFlags: {
          api: apiData(cFlags, false, true),
        },
        doctorFlags: {
          api: apiData(dFlags, false, true),
        },
      };
    }

    case GET_REASONS: {
      return {
        ...state,
        sendOrderToCSReasons: action?.data || [],
      };
    }

    case GET_SCHEDULE_VISITS_CARD_FALIURE: {
      return {
        ...state,
        scheduledVisits: {
          ...state.scheduledVisits,
          lastSyncTime: new Date().getTime(),
          visits: apiData(state.scheduledVisits.visits.data, false, true)
        },
        error: true,
      };
    }
    case GET_PATIENT_INFO_LOADING: {
      const { selectedPatientInfo } = state;
      return {
        ...state,
        selectedPatientInfo: {
          ...selectedPatientInfo,
          api: apiData(selectedPatientInfo.api.data, true, true),
        }
      }
    }
    case GET_PATIENT_INFO: {
      const { selectedPatientInfo } = state;
      return {
        ...state,
        selectedPatientInfo: {
          ...selectedPatientInfo,
          ...action.data,
          api: apiData(selectedPatientInfo.api.data, false, true),
        },
      };
    }
    case GET_PATIENT_INFO_FALIURE: {
      const { selectedPatientInfo } = state;
      return {
        ...state,
        selectedPatientInfo: {
          ...selectedPatientInfo,
          api: apiData(selectedPatientInfo.api.data, false, true),
        },
        errorModalOpen: errorMessage,
      };
    }

    case GET_QTY_BY_PRODUCT_ID_LOADING: {
      const { quantityRangeForProduct } = state;
      return {
        ...state,
        quantityRangeForProduct: {
          ...quantityRangeForProduct,
          api: apiData(quantityRangeForProduct.data, true, true),
        },
      };
    }

    case GET_QTY_BY_PRODUCT_ID: {
      const { quantityRangeForProduct } = state;
      const { data } = action;
      const { pId, quantities, defaultQty } = (() => {
        let quantities = [QUANTITY_RANGE_RESPONSE().api.data];
        let pId = 0;
        let defaultQty = -1;

        try {
          pId = data?.ProductId || -1;

          if (data?.DefaultQty) {
            defaultQty = Number(data.defaultQty);
          }

          const _q = data?.QTY || '0';
          const items = _q.split(',') || [];
          quantities = items.map((item = '') => ({
            id: Number(item),
            value: Number(item),
            label: item,
            description: item,
          }));

          return { pId, quantities, defaultQty };
        } catch (e) {
          return { pId, quantities, defaultQty };
        }
      })();

      return {
        ...state,
        qtyByProduct: data,
        quantityRangeForProduct: {
          ...quantityRangeForProduct,
          api: {
            called: true,
            loading: false,
            data: {
              pId,
              defaultQty,
              quantities,
            },
          },
        },
      };
    }

    case GET_QTY_BY_PRODUCT_ID_FALIURE: {
      const { quantityRangeForProduct } = state;
      return {
        ...state,
        productListModalError: errorMessage,
        quantityRangeForProduct: {
          ...quantityRangeForProduct,
          api: apiData(quantityRangeForProduct.data, false, true),
        },
      };
    }

    case GET_EMAIL_LOADING: {
      return {
        ...state,
        emailMessages: {
          ...state.emailMessages,
          api: apiData(state.emailMessages.api.data, true, true),
        },
      };
    }

    case GET_EMAIL: {
      const { data } = action;
      // const data = EMAIL_MESSAGES
      return {
        ...state,
        emailMessages: {
          ...state.emailMessages,
          api: apiData(data || [], false, true),
        },
        emailData: data,
      };
    }

    case GET_EMAIL_FALIURE: {
      return {
        ...state,
        emailMessages: {
          ...state.emailMessages,
          api: apiData(state.emailMessages.api.data, false, true),
        },
        errorModalOpen: errorMessage,
      };
    }

    case SET_PRODUCT_INFO: {
      return {
        ...state,
        productInfo: {
          ...state.productInfo,
          ...action.data
        },
        isProductChangeModalOpen: false,
      };
    }
    case GET_PRODUCT_INFO_LOADING: {
      const { productInfo } = state;
      return {
        ...state,
        productInfo: {
          ...productInfo,
          api: apiData(productInfo.api.data, true, true)
        },
      };
    }
    case GET_PRODUCT_INFO: {
      let { Product = [], StoreFrontData = {}, OrderId = 0, } = action.data || {};
      // let { Product = [], StoreFrontData = {}, OrderId = 0, } = PRODUCT_INFORMATION;
      const applicationSettings = (() => {
        try {
          return StoreFrontData.StorefrontApplicationSettings || [];
        } catch(e) {
          return [];
        }
      })();

      const configMap = new Map([['', {}]]);
      for (let i = 0; i < applicationSettings.length; i++) {
        const config = applicationSettings[i];
        if (config.SettingName) {
          configMap.set(config.SettingName, {
            name: config.SettingName,
            value: config.SettingValue
          });
        }
      }
      StoreFrontData.StorefrontApplicationSettings = configMap;

      /**
       * @description finds if the order has an alternate rx product
       */
      const hasAlternateRx = hasAlternateRxInOrder({ products: Product });
      const productIds = [];
      const productSet = new Set([0]); productSet.delete(0);
      const productMap = new Map([['', {}]]);
      for (let i = 0; i < Product.length; i++) {
        const _product = Product[i] || {};

        _product.displayTitle = _product.PrescriberProductDisplayName || _product.ProductTitle;
        _product.checked = false;

        /**
         * @description skip checking everything when the product's status is Cancelled. CRW-2743.
         */
        if (isCancelledOrMedicallyDenied({ status: _product.Status })) {
          productMap.set(_product.ProductId, { ..._product });
          productIds.push(_product.ProductId);
          productSet.add(_product.ProductId);
          continue;
        }

        if (hasAlternateRx && _product.ProductId === ALTERNATE_RX_PRODUCT_VALUE) {
          _product.checked = true;
        }

        if (!hasAlternateRx && Product.length >= 1) {
          _product.checked = true;
        }

        productMap.set(_product.ProductId, { ..._product });
        productIds.push(_product.ProductId);
        productSet.add(_product.ProductId);
      }

      const _productInfo = { ...action.data, StoreFrontData, Product, productMap, productIds, productSet };
      const pdfInfo = getPDFTemplate(_productInfo);
      const { productInfoCache, loadingProductInfoCacheForOrderId } = state;
      const _collection = new Map(productInfoCache);
      const _orderIds = new Set(loadingProductInfoCacheForOrderId);

      if (!_collection.has(`${OrderId}`)) {
        _collection.set(`${OrderId}`, productInfo().productInfo);
      }

      const __productInfo = _collection.get(`${OrderId}`);
      __productInfo.OrderId = `${OrderId}`;
      __productInfo.api = apiData(__productInfo.api.data, false, true);
      __productInfo.Product = _productInfo.Product;
      _collection.set(`${OrderId}`, __productInfo);

      _orderIds.delete(`${OrderId}`);

      return {
        ...state,
        productInfo: {
          ...state.productInfo,
          ..._productInfo,
          pdfInfo,
          api: apiData(state.productInfo.api.data, false, true),
        },
        isProductChangeModalOpen: false,
        productInfoCache: _collection,
        loadingProductInfoCacheForOrderId: _orderIds,
      };
    }
    case GET_PRODUCT_INFO_FALIURE: {
      const { productInfo } = state;
      return {
        ...state,
        productInfo: {
          ...productInfo,
          api: apiData(productInfo.api.data, false, true)
        },
        errorModalOpen: errorMessage,
      };
    }
    case RESET_PRODUCT_INFO: {
      return {
        ...state,
        ...productInfo(),
      };
    }

    case GET_PRODUCT_INFO_V3_LOADING: {
      const { OrderId } = action.request;
      const { productInfoCache, loadingProductInfoCacheForOrderId } = state;
      const collection = new Map(productInfoCache);
      const orderIds = new Set(loadingProductInfoCacheForOrderId);
      
      if (!collection.has(`${OrderId}`)) {
        collection.set(`${OrderId}`, productInfo().productInfo);
      }

      const _productInfo = collection.get(`${OrderId}`);
      _productInfo.OrderId = `${OrderId}`;
      _productInfo.api = apiData(_productInfo.api.data, true, true);
      collection.set(`${OrderId}`, _productInfo);

      orderIds.add(`${OrderId}`);

      return {
        ...state,
        productInfoCache: collection,
        loadingProductInfoCacheForOrderId: orderIds,
      };
    }
    case GET_PRODUCT_INFO_V3: {
      let { Product = [], OrderId = 0, } = action.data || {};
      const { productInfoCache, loadingProductInfoCacheForOrderId } = state;
      const _collection = new Map(productInfoCache);
      const _orderIds = new Set(loadingProductInfoCacheForOrderId);

      if (!_collection.has(`${OrderId}`)) {
        _collection.set(`${OrderId}`, productInfo().productInfo);
      }

      for (let i = 0; i < Product.length; i++) {
        Product[i].displayTitle = Product[i].PrescriberProductDisplayName || Product[i].ProductTitle;
        Product[i].checked = true;
      }

      const _productInfo = { ...action.data, Product };

      const __productInfo = _collection.get(`${OrderId}`);
      __productInfo.OrderId = `${OrderId}`;
      __productInfo.api = apiData(__productInfo.api.data, false, true);
      __productInfo.Product = _productInfo.Product;
      _collection.set(`${OrderId}`, __productInfo);

      _orderIds.delete(`${OrderId}`);

      return {
        ...state,
        productInfoCache: _collection,
        loadingProductInfoCacheForOrderId: _orderIds,
      };
    }
    case GET_PRODUCT_INFO_V3_FAILURE: {
      const { productInfoCache, loadingProductInfoCacheForOrderId } = state;
      const _collection = new Map(productInfoCache);
      const _orderIds = new Set(loadingProductInfoCacheForOrderId);

      // expected maximum 1 product info will be fetched at a time
      if (_orderIds.size !== 1) {
        return { ...state };
      }

      const __orderIds = [..._orderIds.keys()];
      const OrderId = `${__orderIds[0]}`;

      const _productInfo = _collection.get(OrderId);
      _productInfo.api = apiData(_productInfo.api.data, false, true);
      _collection.set(OrderId, _productInfo);

      _orderIds.delete(OrderId);

      return {
        ...state,
        productInfoCache: _collection,
        loadingProductInfoCacheForOrderId: _orderIds,
      };
    }
    case CLEAR_PRODUCT_INFO_V3: {
      return {
        ...state,
        ...productInfoCache(),
      };
    }

    case GET_CALL_PATIENT_DETAILS: {
      return {
        ...state,
        callPatientDetails: action.data,
      };
    }
    case SET_CALL_PATIENT_DETAILS: {
      return {
        ...state,
        callPatientDetails: {
          ...state.callPatientDetails,
          DoctorNumber: action.data,
        },
      };
    }
    case RESET_CALL_PATIENT_DETAILS: {
      return {
        ...state,
        callPatientDetails: {},
        callToPatientStatus: false,
        isModalTwilioAlertOpen: false,
      };
    }
    case CALL_PATIENT_LOADING: {
      const { callPatient } = state;
      return {
        ...state,
        callPatient: {
          ...callPatient,
          api: apiData(callPatient.api.data, true, true),
        },
      };
    }
    case CALL_PATIENT: {
      const { callPatient } = state;
      return {
        ...state,
        callToPatientStatus: true,
        callPatientDetails: {
          ...state.callPatientDetails,
          RoomId: (action.data && action.data.roomId) ? action.data.roomId : '',
        },
        callPatient: {
          ...callPatient,
          api: apiData(callPatient.api.data, false, true),
        }
      };
    }
    case SET_MODAL_TWILIO_ALERT_OPEN: {
      return {
        ...state,
        isModalTwilioAlertOpen: action.data,
      };
    }
    case CALL_PATIENT_FAILURE: {
      const { callPatient } = state;
      const nextState = { ...state };

      if (
        action.error &&
        action.error.data &&
        action.error.data.StatusCode === 400
      ) {
        nextState.isModalTwilioAlertOpen = errorMessage;
      } else {
        let type = true;
        if (connectionError) {
          type = errorMessage;
        }
        nextState.isModalAlertOpen = type;
      }

      return {
        ...nextState,
        callPatient: {
          ...callPatient,
          api: apiData(callPatient.api.data, false, true),
        },
      };
    }
    case EMAIL_PATIENT_DATA_LOADING: {
      const { emailPatient } = state;
      return {
        ...state,
        emailPatient: {
          ...emailPatient,
          api: apiData(emailPatient.api.data, true, true),
        },
      };
    }
    case EMAIL_PATIENT_DATA: {
      const { emailPatient } = state;
      return {
        ...state,
        isEmailSentToPatient: true,
        emailPatient: {
          ...emailPatient,
          api: apiData(emailPatient.api.data, false, true),
        },
      };
    }
    case EMAIL_PATIENT_DATA_FAILURE: {
      const { emailPatient } = state;
      let type = true;
      if (connectionError) {
        type = errorMessage;
      }
      return {
        ...state,
        isModalAlertOpen: type,
        emailPatient: {
          ...emailPatient,
          api: apiData(emailPatient.api.data, false, true),
        },
      };
    }

    case UPLOAD_DOC_PATIENT: {
      let uploadedDocsTemp = action.data;
      uploadedDocsTemp.length !== 0 &&
        uploadedDocsTemp.forEach((element) => {
          // element.DocumentUploadImages = DOCUMENT_UPLOADED_IMAGES;
          element.DocumentUploadImages.length !== 0 &&
            element.DocumentUploadImages.forEach((images) => {
              images.Expanded = false;
            });
        });
      return {
        ...state,
        uploadedDocs: uploadedDocsTemp,
      };
    }

    case SET_UPLOAD_DOCS: {
      return {
        ...state,
        uploadedDocs: action.data,
      };
    }

    case PDF_DOC: {
      let uploadedPdfsTemp = action.data;
      uploadedPdfsTemp.length !== 0 && uploadedPdfsTemp.DocumentUploadImages.forEach(images => {
          images.Expanded = false;
      });
      return {
        ...state,
        uploadedPdfs: uploadedPdfsTemp
      }
    }

    case PDF_AV_LOADING: {
      const { orderId } = action.data;
      return { ...state, getPdf: { orderId, api: apiData({}, true, true) } };
    }

    case PDF_AV: {
      let uploadedPdfsTemp = action.data;
      const getPdf = { ...state.getPdf, api: apiData({}, false, true) };
      if(uploadedPdfsTemp.length !== 0 && uploadedPdfsTemp.DocumentUploadImages.length > 0){
        return {
          ...state,
          getPdf,
          pdfExists: true
        }
      } else {
        return {
          ...state,
          getPdf,
          pdfExists: false
        }
      }      
    }

    case PDF_NAV: {
      return {
        ...state,
        errorModalOpen: errorMessage,
        getPdf: { ...state.getPdf, api: apiData({}, false, true) }
      };
    }

    case SET_UPLOAD_PDFS: {
      return {
        ...state,
        uploadedPdfs: action.data
      }
    }

    case LOG_OFF_FALIURE:
    case LOG_OFF: {
      localStorage.removeItem("userData");
      localStorage.removeItem("userId");
      return {
        ...state,
        loggedOff: true,
      };
    }
    //modal Alert modal
    case GET_TEXT_PATIENT_TEMPLATE_FALIURE:
    case VERIFY_PIN_FALIURE:
    case GET_DENIAL_REASON_FAILURE:
    case GET_SUB_AND_EMAIL_FALIURE:
    case APPROVE_AND_MAIL_SUBMIT_FALIURE:
    case SEND_ORDER_TO_CS_FALIURE:
    case DENIAL_AND_EMAIL_FALIURE:
    case ADD_NOTE_FAILURE:
    case GET_CALL_PATIENT_DETAILS_FAILURE:
    case GET_DOSESPOT_DATA_FALIURE:
    case GET_EMAIL_TEMPLATE_FALIURE: {
      let type = true;
      if (connectionError) {
        type = errorMessage;
      }
      return {
        ...state,
        isModalAlertOpen: type,
      };
    }

    //app alert
    case GET_PRODUCT_LIST_FALIURE:
    case GET_NOTES_FALIURE:
    case GET_REASONS_FALIURE:
    case SET_START_VISIT_FALIURE:
    case POST_CALL_DETAILS_FALIURE:
    case CALL_END_FAILURE:
    case LOG_ERROR_FALIURE:
    case CHECK_DOSESPOT_FALIURE:
    case UPLOAD_DOC_PATIENT_FAILURE: 
    case PDF_DOC_FAILURE: {
      return {
        ...state,
        errorModalOpen: errorMessage,
      };
    }

    case GET_HEADER_INFO_LOADING: {
      const { headerInfoAPI } = state;
      return {
        ...state,
        headerInfoAPI: apiData(headerInfoAPI.data, true, true),
      };
    }

    case GET_HEADER_INFO: {
      const { headerInfoAPI } = state;
      return {
        ...state,
        selectedPrescriberInfo: action.data,
        headerInfoAPI: apiData(headerInfoAPI.data, false, true),
      };
    }
    case GET_HEADER_INFO_FALIURE: {
      const { headerInfoAPI } = state;
      return {
        ...state,
        selectedPrescriberInfo: {},
        error: true,
        headerInfoAPI: apiData(headerInfoAPI.data, false, true),
      };
    }

    //search reducer

    case SET_SEARCH_ERROR: {
      return {
        ...state,
        searchError: 1,
      };
    }

    case SET_SEARCH_DATA: {
      const { searchOrdersAPI } = state;
      return {
        ...state,
        searchData: action.data || [],
        searchError: 0,
        searchOrdersAPI: apiData(searchOrdersAPI.data, false, true),
      };
    }
    case CLEAR_SEARCH_DATA: {
      return {
        ...state,
        ...searchOrdersAPI(),
        searchData: [],
        searchError: 0,
      };
    }
    case SET_SEARCH_DATA_FAILURE: {
      const { searchOrdersAPI } = state;
      return {
        ...state,
        searchData: [],
        searchError: 2,
        searchOrdersAPI: apiData(searchOrdersAPI.data, false, true),
      };
    }
    case SET_SEARCH_LOADING: {
      const { searchOrdersAPI } = state;
      return {
        ...state,
        searchOrdersAPI: apiData(searchOrdersAPI.data, true, true),
      };
    }
    case CALL_SUMMARY_REASONS: {
      return {
        ...state,
        callSummary: {
          value: state.callSummary.value,
          reasons: action.data,
        }
      };
    }
    case SET_CALL_SUMMARY: {
      return {
        ...state,
        callSummary: {
          value: action.data.value,
          reasons: state.callSummary.reasons,
        }
      }
    }
    case SET_FILTER_BY: {
      const { data } = action;
      const { target } = data;
      let filterBy = data.value;
      switch (target) {
        case 'scheduledVisits':
        case 'asyncOrders': {
          return {
            ...state,
            [target]: {
              ...state[target],
              filterBy
            }
          };
        }
        default: return state;
      }
    }
    case SET_CMN_TEMPLATE_FORM_FIELD: {
      const { data: cmnTemplateFormField } = action;
      return { ...state, cmnTemplateFormField };
    }

    case SET_SOAP_NOTE_TEMPLATE: {
      const { value = -1 } = action.data;
      const { soapNoteTemplates } = state;
      return {
        ...state,
        soapNoteTemplates: {
          ...soapNoteTemplates,
          value,
        },
      };
    }
    case GET_SOAP_NOTE_TEMPLATES_LOADING: {
      const { soapNoteTemplates } = state;
      return {
        ...state,
        soapNoteTemplates: {
          ...soapNoteTemplates,
          api: apiData(soapNoteTemplates.api.data, true, true)
        }
      };
    }
    case GET_SOAP_NOTE_TEMPLATES: {
      const { soapNoteTemplates } = state;
      const valuesCollection = new Map([
        [-1, DROPDOWN()],
      ]);
      let templates = [DROPDOWN()];
      templates = [];

      for (let i = 0; i < action?.data?.length; i++) {
        const template = action.data[i];
        const _template = {
          ...template,
          id: template.Id,
          value: template.Id,
          label: template.TemplateTitle,
          description: template.TemplateText,
        };
        valuesCollection.set(template.Id, _template);
        templates.push(_template);
      }

      return {
        ...state,
        soapNoteTemplates: {
          ...soapNoteTemplates,
          valuesCollection,
          api: apiData(templates, false, true)
        }
      };
    }
    case GET_SOAP_NOTE_TEMPLATES_FAILURE: {
      const { soapNoteTemplates } = state;
      return {
        ...state,
        soapNoteTemplates: {
          ...soapNoteTemplates,
          api: apiData(soapNoteTemplates.api.data, false, true)
        }
      };
    }
    case GET_PATIENT_UPLOADS_LOADING: {
      const { patientUploads } = state;
      return {
        ...state,
        patientUploads: {
          ...patientUploads,
          api: apiData(patientUploads.api.data, true, true)
        }
      };
    }
    case GET_PATIENT_UPLOADS: {
      const { patientUploads } = state;
      const valuesCollection = new Map();
      /**
       * @type {{
       * }[]}
       */
      const data = action?.data || [];

      // temporary change for development purpose
      // action.data = PATIENT_UPLOADS;

      const formattedList = data.map((props) => {
        const { DocumentId, OrderId, CreatedAt } = props;
        const _u = {
          ...props,
          uniqueId: `${OrderId}-${randomNumber()}`,
          createdAtTime: new Date(CreatedAt).getTime(),
        };
        valuesCollection.set(DocumentId, _u);
        return _u;
      });

      const sortedList = sort(formattedList, 'createdAtTime', Order.desc, ColumnType.date);

      return {
        ...state,
        patientUploads: {
          ...patientUploads,
          valuesCollection,
          api: apiData(sortedList, false, true)
        }
      };
    }
    case GET_PATIENT_UPLOADS_FAILURE: {
      const { patientUploads } = state;
      return {
        ...state,
        patientUploads: {
          ...patientUploads,
          api: apiData(patientUploads.api.data, false, true)
        }
      };
    }
    case GET_CHANGE_PRODUCT_LIST_LOADING: {
      const { changeProducts } = state;
      return {
        ...state,
        changeProducts: {
          ...changeProducts,
          api: apiData(changeProducts.api.data, true, true),
        }
      };
    }
    case GET_CHANGE_PRODUCT_LIST: {
      const { changeProducts } = state;
      const { data: productCollection } = action;
      return {
        ...state,
        changeProducts: {
          ...changeProducts,
          api: apiData(productCollection, false, true),
        }
      };
    }
    case GET_CHANGE_PRODUCT_LIST_FAILURE: {
      const { changeProducts } = state;
      return {
        ...state,
        changeProducts: {
          ...changeProducts,
          api: apiData(changeProducts.api.data, false, true),
        }
      };
    }
    case RESET_CHANGE_PRODUCT_LIST: {
      return {
        ...state,
        ...changeProducts(),
      };
    }

    case GET_ALL_SUB_AND_EMAIL_LOADING: {
      const { emailSubjects } = state;
      return {
        ...state,
        emailSubjects: {
          ...emailSubjects,
          api: apiData(emailSubjects.api.data, true, true),
        }
      };
    }
    case GET_ALL_SUB_AND_EMAIL: {
      const { emailSubjects } = state;
      const { data: valuesCollection } = action;
      return {
        ...state,
        emailSubjects: {
          ...emailSubjects,
          api: apiData(valuesCollection, false, true),
        }
      };
    }
    case GET_ALL_SUB_AND_EMAIL_FAILURE: {
      const { emailSubjects } = state;
      return {
        ...state,
        emailSubjects: {
          ...emailSubjects,
          api: apiData(emailSubjects.api.data, false, true),
        }
      };
    }

    case GET_EMAIL_REASONS_LOADING: {
      const { emailReasons } = state;
      return {
        ...state,
        emailReasons: {
          ...emailReasons,
          api: apiData(emailReasons.api.data, true, true),
        },
      };
    }
    case GET_EMAIL_REASONS: {
      const { emailReasons } = state;
      /**
       * @type {{}[]}
       */
      const data = action?.data || [];

      const valuesCollection = new Map([
        [0, emailReason()],
      ]);
      for (let i = 0; i < data.length; i++) {
        const { Id: id, TemplateTitle: label, RequiredText: required, TemplateText: description } = data[i];
        const reason = {
          id,
          label,
          value: id,
          required,
          description,
        };
        if (reason.required) {
          reason.description = '';
        }
        data[i] = reason;
        valuesCollection.set(reason.id, reason);
      }

      return {
        ...state,
        emailReasons: {
          ...emailReasons,
          valuesCollection,
          api: apiData(data, false, true),
        },
      };
    }
    case GET_EMAIL_REASONS_FAILURE: {
      const { emailReasons } = state;
      return {
        ...state,
        emailReasons: {
          ...emailReasons,
          api: apiData(emailReasons.api.data, false, true),
        },
      };
    }

    case GET_PRODUCT_COST_LOADING: {
      const { productCost } = state;
      return {
        ...state,
        productCost: {
          ...productCost,
          api: apiData(productCost.api.data, true, true),
        }
      };
    }
    case GET_PRODUCT_COST: {
      const { productCost } = state;
      const { data: __productCost } = action;
      return {
        ...state,
        productCost: {
          ...productCost,
          api: apiData(__productCost, false, true),
        }
      };
    }
    case GET_PRODUCT_COST_FAILURE: {
      const { productCost } = state;
      return {
        ...state,
        productCost: {
          ...productCost,
          api: apiData(productCost.api.data, false, true),
        }
      };
    }
    case RESET_PRODUCT_COST: {
      return {
        ...state,
        ...productCost(),
        ...addProductInfo(),
      };
    }

    case ADD_PRODUCT_LOADING: {
      const { addProductInfo } = state;
      return {
        ...state,
        addProductInfo: {
          ...addProductInfo,
          api: apiData(addProductInfo.api.data, true, true),
        }
      };
    }
    case ADD_PRODUCT: {
      const { addProductInfo } = state;
      const { data: _addProductInfo } = action;
      return {
        ...state,
        addProductInfo: {
          ...addProductInfo,
          api: apiData(_addProductInfo, false, true),
        }
      };
    }
    case ADD_PRODUCT_FAILURE: {
      const { addProductInfo } = state;
      return {
        ...state,
        addProductInfo: {
          ...addProductInfo,
          api: apiData(addProductInfo.api.data, false, true),
        }
      };
    }

    case GET_SAVED_FLAGS_LOADING: {
      return {
        ...state,
        savedFlags: {
          ...state.savedFlags,
          api: apiData(state.savedFlags.api.data, true, true),
        }
      };
    }
    case GET_SAVED_FLAGS: {
      const { data: flags = [] } = action;
      let _formattedFlags = [SAVED_FLAG()];
      _formattedFlags = [];
      const flagsCollection = new Map([
        ['', SAVED_FLAG()],
      ]);
      flagsCollection.delete('');

      for (let i = 0; i < flags.length; i++) {
        const flag = flags[i];
        const flagId = Number(flag.FlagId);
        const productId = Number(flag.ProductId);

        const _formattedFlag = {
          id: Number(flag.Id),
          flagId,
          flagType: flag.Flagtype,
          checked: flag.Acknowledgment,
          note: flag.Flagtext,
          required: true,
          orderId: Number(flag.OrderId),
          productId,
          questionId: Number(flag.QuestionId),
          updatedBy: flag.UpdatedBy,
          updatedAt: flag.UpdatedAt,
          responseId: `${productId}-${flagId}`,
        };
        _formattedFlags[i] = _formattedFlag;
        flagsCollection.set(_formattedFlag.responseId, _formattedFlag);
      }

      return {
        ...state,
        savedFlags: {
          ...state.savedFlags,
          flagsCollection,
          api: apiData(_formattedFlags, false, true),
        }
      };
    }
    case GET_SAVED_FLAGS_FAILURE: {
      return {
        ...state,
        savedFlags: {
          ...state.savedFlags,
          api: apiData(state.savedFlags.api.data, false, true),
        }
      };
    }
    case RESET_SAVED_FLAGS: {
      return {
        ...state,
        ...savedFlags(),
      };
    }

    case SAVE_FLAGS_LOADING: {
      return {
        ...state,
        saveFlags: {
          ...state.saveFlags,
          api: apiData(state.saveFlags.api.data, true, true),
        }
      };
    }
    case SAVE_FLAGS:
    case SAVE_FLAGS_FAILURE: {
      return {
        ...state,
        saveFlags: {
          ...state.saveFlags,
          api: apiData(action.data, false, true),
        }
      };
    }

    case SAVE_EXTENDED_CONSULT_LOADING: {
      return {
        ...state,
        saveExtendedConsult: {
          ...state.saveExtendedConsult,
          api: apiData(state.saveExtendedConsult.api.data, true, true),
        }
      };
    }

    case SAVE_EXTENDED_CONSULT:
    case SAVE_EXTENDED_CONSULT_FAILURE:{
      return {
        ...state,
        saveExtendedConsult: {
          ...state.saveExtendedConsult,
          api: apiData(state.saveExtendedConsult.api.data, false, true),
        }
      };
    }

    case SEND_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          sendOTP: apiData(recoverPassword.sendOTP.data, true, true),
        },
      };
    }
    case SENT_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;
      const data = action?.data || {};

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          sendOTP: apiData(data, false, true),
        },
      };
    }
    case FAILD_TO_SEND_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          sendOTP: apiData({}, false, true),
        },
      };
    }

    case VALIDATE_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          validateOTP: apiData(recoverPassword.validateOTP.data, true, true),
        },
      };
    }
    case VALIDATED_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;
      const data = action?.data || {};

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          validateOTP: apiData(data, false, true),
        },
      };
    }
    case FAILED_TO_VALIDATE_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          validateOTP: apiData({}, false, true),
        },
      };
    }

    case RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          resetUsingOTP: apiData(recoverPassword.resetUsingOTP.data, true, true),
        },
      };
    }
    case PASSWORD_IS_RESET_USING_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;
      const data = action?.data || {};

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          resetUsingOTP: apiData(data, false, true),
        },
      };
    }
    case FAILED_TO_RESET_PASSWORD_USING_PASSWORD_RECOVERY_OTP: {
      const { recoverPassword } = state;

      return {
        ...state,
        recoverPassword: {
          ...recoverPassword,
          resetUsingOTP: apiData({}, false, true),
        },
      };
    }

    case SAVE_PRODUCT_CHANGES_LOADING: {
      return {
        ...state,
        changeProductForOrderAPI: apiData({}, true, true),
      };
    }

    case SAVE_PRODUCT_CHANGES: {
      return {
        ...state,
        changeProductForOrderAPI: apiData({}, false, true),
      };
    }

    case SAVE_PRODUCT_CHANGES_FALIURE: {
      return {
        ...state,
        productListModalError: errorMessage,
        changeProductForOrderAPI: apiData({}, false, true),
      };
    }

    case CLEAR_RECOVER_PASSWORD: {
      return {
        ...state,
        ...recoverPassword(),
      };
    }

    case GET_TASKS_LOADING: {
      const { tasksInfo } = state;
      return {
        ...state,
        tasksInfo: {
          ...tasksInfo,
          ...apiData(tasksInfo.data, true, true),
        },
      };
    }

    case GET_TASKS: {
      const data = action?.data || [];
      const sorted = formattedAndSortedTasks(noCompletedTask(data));
      return {
        ...state,
        tasksInfo: {
          ...apiData(sorted, false, true),
          lastSyncTime: new Date().getTime(),
        },
      };
    }

    case GET_TASKS_FAILURE: {
      const data = action?.data || [];
      // const data = TASKS();
      const sorted = formattedAndSortedTasks(noCompletedTask(data));
      return {
        ...state,
        tasksInfo: {
          ...apiData(sorted, false, true),
          lastSyncTime: new Date().getTime(),
        },
      };
    }

    case GET_TASK_BY_ORDER_ID_LOADING: {
      const { tasksInfoByOrderId } = state;
      return {
        ...state,
        tasksInfoByOrderId: apiData(tasksInfoByOrderId.data, true, true),
      };
    }

    case GET_TASK_BY_ORDER_ID: {
      const data = action?.data || [];
      const sorted = formattedAndSortedTasks(data);
      return {
        ...state,
        tasksInfoByOrderId: apiData(sorted, false, true),
      };
    }

    case GET_TASK_BY_ORDER_ID_FAILURE: {
      const data = action?.data || [];
      const sorted = formattedAndSortedTasks(data);
      return {
        ...state,
        tasksInfoByOrderId: apiData(sorted, false, true),
      };
    }

    case GET_ICD10CODES_BY_TERMS_LOADING: {
      const { icd10CodesByTerms } = state;
      return {
        ...state,
        icd10CodesByTerms: apiData(icd10CodesByTerms.data, true, true),
      };
    }

    case GET_ICD10CODES_BY_TERMS: {
      /**
       * @type {{
       *  icd10CodesByTerms: {
       *    data: {
       *      icd10CodesCollection: Map<string, string>;
       *    };
       *  };
       * }}
       */
      const { icd10CodesByTerms } = state;
      const [count, icd10Codes, error, icd10CodesWithDescription] = action?.data || [0, [], null, []];
      /**
       * @type {Map<string, string>}
       */
      const icd10CodesCollection = new Map([...icd10CodesByTerms.data.icd10CodesCollection, ...icd10CodesWithDescription]);

      return {
        ...state,
        icd10CodesByTerms: apiData({
          count,
          icd10Codes,
          error,
          icd10CodesCollection,
          icd10CodesWithDescription,
        }, false, true),
      };
    }

    case CLEAR_ICD10CODES_BY_TERMS: {
      return {
        ...state,
        ...icd10CodesByTerms(),
      };
    }

    case GET_ICD10CODES_BY_TERMS_FAILURE: {
      const { icd10CodesByTerms } = state;
      return {
        ...state,
        icd10CodesByTerms: apiData(icd10CodesByTerms.data, false, true),
      };
    }

    case GET_ICD10CODES_BY_ORDER_ID_LOADING: {
      const { icd10CodesByOrderId } = state;
      return {
        ...state,
        icd10CodesByOrderId: apiData(icd10CodesByOrderId.data, true, true),
      };
    }

    case GET_ICD10CODES_BY_ORDER_ID: {
      /**
       * @type {Map<string, {
       *    Id: number;
       *    ICDCode: string;
       *    ICDDesc: string;
       * }>}
       */
      const icd10CodesCollection = new Map();
      /**
       * @type {{
       *  Id: number;
       *  ICDCode: string;
       *  ICDDesc: string;
       *  OrderId: number;
       * }[]}
       */
      const icd10Codes = action?.data?.OrderCodes || [];
      icd10Codes.forEach((item) => {
        icd10CodesCollection.set(item.ICDCode, item);
      });

      /**
       * @type {{
       *  icd10CodesByTerms: {
       *    data: {
       *      icd10CodesCollection: Map<string, string>;
       *    };
       *  };
       * }}
       */
      const { icd10CodesByTerms } = state;
      const icd10CodesCollectionV2 = new Map(icd10CodesByTerms.data.icd10CodesCollection);

      /**
       * @type {{
       *  Id: number;
       *  ICDCode: string;
       *  ICDDesc: string;
       *  SortIndex: number;
       *  ProductBaseGroupId: number;
       * }[]}
       */
      const recommendedCodes = sortBy(action?.data?.RecommendedCodes || [], ['SortIndex']);
      recommendedCodes.forEach((item) => {
        icd10CodesCollectionV2.set(item.ICDCode, item.ICDDesc);
      });

      return {
        ...state,
        icd10CodesByOrderId: apiData({
          icd10Codes,
          recommendedCodes,
          icd10CodesCollection
        }, false, true),
        icd10CodesByTerms: {
          ...icd10CodesByTerms,
          data: {
            ...icd10CodesByTerms.data,
            icd10CodesCollection: icd10CodesCollectionV2,
          },
        },
      };
    }

    case GET_ICD10CODES_BY_ORDER_ID_FAILURE: {
      const { icd10CodesByOrderId } = state;
      return {
        ...state,
        icd10CodesByOrderId: apiData(icd10CodesByOrderId.data, false, true),
      };
    }

    case REMOVE_ICD10CODE_FROM_COLLECTION: {
      const { icd10CodesByOrderId } = state;
      const { code } = action.data;

      const icd10Codes = [...icd10CodesByOrderId.data.icd10Codes];
      const codeIndex = icd10Codes.findIndex(({ ICDCode }) => ICDCode === code);
      if (codeIndex > -1) {
        icd10Codes.splice(codeIndex, 1);
      }

      return {
        ...state,
        icd10CodesByOrderId: apiData({
          ...icd10CodesByOrderId.data,
          icd10Codes,
        }, false, true),
      };
    }

    case GET_ICD10CODES_BY_PATIENT_ID_LOADING: {
      const { icd10CodesByPatientId } = state;
      return {
        ...state,
        icd10CodesByPatientId: apiData(icd10CodesByPatientId.data, true, true),
      };
    }

    case GET_ICD10CODES_BY_PATIENT_ID: {
      const data = action?.data || [];
      return {
        ...state,
        icd10CodesByPatientId: apiData(data, false, true),
      };
    }

    case GET_ICD10CODES_BY_PATIENT_ID_FAILURE: {
      const { icd10CodesByPatientId } = state;
      return {
        ...state,
        icd10CodesByPatientId: apiData(icd10CodesByPatientId.data, false, true),
      };
    }

    case ADD_ICD10CODES_LOADING: {
      const { addICD10CodesAPI } = state;
      return {
        ...state,
        addICD10CodesAPI: apiData(addICD10CodesAPI.data, true, true),
      };
    }

    case ADD_ICD10CODES: {
      const { addICD10CodesAPI } = state;
      return {
        ...state,
        addICD10CodesAPI: apiData(addICD10CodesAPI.data, false, true),
      };
    }

    case ADD_ICD10CODES_FAILURE: {
      const { addICD10CodesAPI } = state;
      return {
        ...state,
        addICD10CodesAPI: apiData(addICD10CodesAPI.data, false, true),
      };
    }

    case REMOVE_ICD10CODES_LOADING: {
      const { removeICD10CodesAPI } = state;
      return {
        ...state,
        removeICD10CodesAPI: apiData(removeICD10CodesAPI.data, true, true),
      };
    }

    case REMOVE_ICD10CODES: {
      const { removeICD10CodesAPI } = state;
      return {
        ...state,
        removeICD10CodesAPI: apiData(removeICD10CodesAPI.data, false, true),
      };
    }

    case REMOVE_ICD10CODES_FAILURE: {
      const { removeICD10CodesAPI } = state;
      return {
        ...state,
        removeICD10CodesAPI: apiData(removeICD10CodesAPI.data, false, true),
      };
    }

    case CHANGE_PASSWORD_IN_PROGRESS: {
      const { changePasswordAPI } = state;
      return {
        ...state,
        changePasswordAPI: {
          ...changePasswordAPI,
          called: true,
          loading: true,
        },
      };
    }

    case PASSWORD_IS_CHANGED: {
      const { changePasswordAPI } = state;
      return {
        ...state,
        changePasswordAPI: {
          ...changePasswordAPI,
          called: true,
          loading: false,
        },
      };
    }

    case FAILED_TO_CHANGE_PASSWORD: {
      const { changePasswordAPI } = state;
      return {
        ...state,
        changePasswordAPI: {
          ...changePasswordAPI,
          called: true,
          loading: false,
        },
      };
    }

    default:
      return state;
  }
};

export default userReducer;
